import { useMediaQuery } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import BaseCarousel from '../../../../../commons/components/ui/BaseCarousel/BaseCarousel';
import styles from './BannerCarousal.module.scss';
import BannerImage from './BannerImage';
import Overlay from './Overlay';
import OverlayPager from './OverlayPager';
import { rfPainRelief } from '../../../../../src/images';
import {
  testImg1,
  testImg2,
  testImg3,
  testImg4,
  testImg5,
  testImg6,
  testImg7,
  testImg8,
  testImg9,
} from '../../../../../src/images';
import { ProductsCategory } from '../../../../../config';

const customerStoriesContent = [
  {
    id: 1,
    review: 'I absolutely love Relief Factor. I tell all my friends about it.',
    name: '- Drew M.',
    //duration: 'Relief Factor User, 3 Years',
    productImg: rfPainRelief,
    category: 'Pain Relief',
    productName: 'Relief Factor',
    link: '/products/relief-factor',
    gradient: '#9cd4ea87',
    testimonialImg: testImg1,
    testimonialTabImg: testImg2,
    testimonialMbImg: testImg3,
    product: ProductsCategory.RELIEF_FACTOR,
  },
  {
    id: 2,
    review:
      "If your knees hurt bad enough - which mine were - you’ll try just about anything…After four days, I thought, ‘My knees aren’t hurting!' I’ve been taking it ever since.",
    name: '- Dale',
    productImg: rfPainRelief,
    category: 'Pain Relief',
    productName: 'Relief Factor',
    link: '/products/relief-factor',
    gradient: '#9cd4ea87',
    testimonialImg: testImg4,
    testimonialTabImg: testImg5,
    testimonialMbImg: testImg6,
    product: ProductsCategory.RELIEF_FACTOR,
  },
  {
    id: 3,
    review:
      'The biggest difference is in how I was sleeping. Relief Factor, I feel…has improved my quality of life…It’s like the best thing in the world.',
    name: '- Sandy',
    productImg: rfPainRelief,
    category: 'Pain Relief',
    productName: 'Relief Factor',
    link: '/products/relief-factor',
    gradient: '#9cd4ea87',
    testimonialImg: testImg7,
    testimonialTabImg: testImg8,
    testimonialMbImg: testImg9,
    product: ProductsCategory.RELIEF_FACTOR,
  },
];

function TestimonialCarousel({ id }) {
  const overlayContainerRef = useRef(null);
  const baseCarouselRef = useRef(null);
  const [marginLeft, setMarginLeft] = useState(0);
  const [currentSlideIdx, setCurrentSlideIdx] = useState(0);

  const updateContainerMargin = () => {
    const parentWidth = window.innerWidth;
    if (overlayContainerRef?.current?.clientWidth) {
      const containerWidth = overlayContainerRef.current.clientWidth;
      const leftMargin = (parentWidth - containerWidth) / 2;
      setMarginLeft(leftMargin);
    }
  };

  useEffect(() => {
    updateContainerMargin();
    window.addEventListener('resize', updateContainerMargin);

    return () => {
      window.removeEventListener('resize', updateContainerMargin);
      updateContainerMargin();
    };
  }, []);

  const next = () => {
    if (baseCarouselRef.current) baseCarouselRef.current.handleNext();
  };
  const prev = () => {
    if (baseCarouselRef.current) baseCarouselRef.current.handlePrev();
  };

  const handleSlideChange = (index) => setCurrentSlideIdx(index);

  const isMobile = useMediaQuery('(max-width:880px)');
  const slides = customerStoriesContent.map((item) => {
    return {
      key: item.id,
      component: (
        <BannerImage
          img={item.testimonialImg}
          tabImg={item.testimonialTabImg}
          mobileImg={item.testimonialMbImg}
          altText={item.title1}
        ></BannerImage>
      ),
    };
  });

  return (
    <div className={styles.HomePageCarousal} id={id}>
      <BaseCarousel
        handleSlideChange={handleSlideChange}
        ref={baseCarouselRef}
        items={slides}
        options={getConfigurableProps()}
        className={styles.testimonialCarousel}
      />

      <div ref={overlayContainerRef} className={styles.overlayPosition}>
        <Overlay
          leftBtn={prev}
          rightBtn={next}
          data={customerStoriesContent[currentSlideIdx]}
          currentSlide={currentSlideIdx + 1}
          totalSlideCount={customerStoriesContent.length}
        ></Overlay>
      </div>
      <div
        className={styles.overlayPagerPosition}
        style={{
          marginLeft: isMobile ? `${marginLeft}px` : '0px',
          marginBottom: '15px',
          left: isMobile ? '0px' : '3%',
        }}
      >
        <OverlayPager
          leftBtn={prev}
          rightBtn={next}
          current={currentSlideIdx + 1}
          end={customerStoriesContent.length}
        />
      </div>
    </div>
  );
}

export default TestimonialCarousel;

const getConfigurableProps = () => ({
  showArrows: false,
  showStatus: false,
  showIndicators: false,
  infiniteLoop: true,
  showThumbs: false,
  useKeyboardArrows: true,
  stopOnHover: true,
  swipeable: false,
  dynamicHeight: true,
  emulateTouch: true,
  autoFocus: false,
  thumbWidth: 100,
  autoPlay: false,
  interval: 2000,
  transitionTime: 500,
  swipeScrollTolerance: 5,
});
